//  These widths come from design depending on the rule time.
export const widthGenerator = (time: number) => {
	if (time < 5) {
		return 10;
	}
	if (time >= 5 && time < 10) {
		return 30;
	}
	if (time >= 10 && time < 15) {
		return 60;
	}
	if (time >= 15 && time < 20) {
		return 90;
	}
	if (time >= 20 && time < 25) {
		return 120;
	}
	if (time >= 25 && time < 30) {
		return 160;
	}
	if (time === 30) {
		return 190;
	}
	return 200;
};
